<template>
    <v-card width="100%" class="mt-3 pt-3 pl-3 pr-3" color="#eee">
        <v-row>
            <v-col cols="12" sm="12">
                <h3>{{index}}. {{question.title}}</h3>
            </v-col>
            <v-col cols="12" sm="12" class="ml-3">
                <p>{{question.description}}</p>
            </v-col>
            <v-col cols="12" sm="12">
                <v-row class="pl-3 pr-3">
                    <v-textarea v-model="ans" outlined label="回答區域" :disabled="true"></v-textarea>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    props:{
        index: {
            type: Number,
            default: -1,
        },
        question: {
            type: Object, 
            default: {
                title: "",
                description: "",
            }
        },
        ans: {
            type: String,
            default: ''
        }
    },
}
</script>